import Carousel from 'react-bootstrap/Carousel';
import './VideoCarousel.css'; // Define styles for overlay, text, etc.
import Card00 from '../cards/Card00';
import Card01 from '../cards/Card01';
import MS from '../mainpagelinks/aboutus/MissionStatement'




function VideoCarousel() {
  return (
    <div>
      <div className="video-carousel-wrapper">
        <video autoPlay loop muted playsInline className="background-video">
          <source src={`${process.env.PUBLIC_URL}/video09.mp4`} type="video/mp4" />
          Your browser does not support the video tag.
        </video>

        {/* <div className="video-overlay">
          <Carousel indicators={false} controls={false} fade interval={5000}>
            <Carousel.Item>
              <div className="carousel-content">
                <h1>Empowering Minds Through Education</h1>
                <p>Unlock potential, inspire growth, and shape the future—one learner at a time.</p>
              </div>
            </Carousel.Item>
            </Carousel>
        </div> */}
      </div>
      <Card00 />
      <Card01 />
   
      {/* <MissionStatement /> */}
    </div>
  );
}

export default VideoCarousel;



// import Carousel from 'react-bootstrap/Carousel';
// import './VideoCarousel.css'; // We'll define overlay styles here
// import Card00 from '../cards/Card00'
// import Card01 from '../cards/Card01'

// function VideoCarousel() {
//   return (
//     <div>

    
//     <div className="video-carousel-wrapper">
//       <video autoPlay loop muted playsInline className="background-video">
//         <source src={`${process.env.PUBLIC_URL}/video08.mp4`} type="video/mp4" />
         
//         Your browser does not support the video tag.
//       </video>

//       <div className="video-overlay">
//         <Carousel indicators={false} controls={false} fade interval={5000}>
//           <Carousel.Item>
//             {/* <div className="carousel-content">
//               <h1>Where Inclusion is a strength</h1>
//               <p>And Diversity is a Force</p>
//             </div> */}
//           </Carousel.Item>
//           {/* Add more Carousel.Items here if needed */}
//         </Carousel>
//       </div>
//     </div>
//        <Card00 />
//         <Card01 />
//        </div>
//   );
// }

// export default VideoCarousel;
